import messageImg from "../picture/Message.png";
import penImg from "../picture/Pen.png";
import categoriesImg from "../picture/Category.png";
import imagesImg from "../picture/slika.png";
import sendImg from "../picture/slanje.png";
import attachImg from "../picture/Prilog.png";
import twoArrow from "../picture/TwoArrow.png";
import downloadFileImg from "../picture/DownloadFile.png";
import oneImageDocument from "../picture/OneImageDocument.png";
import noneVisible from "../picture/VisibleNon.png";
import onePictureMaxImg from "../picture/OnePictureMax.png";
import Categories from "../Categories/Categories.jsx";
import { useEffect, useState } from "react";
import "./modal.css"; // You'll need to create this CSS file
import text41Img from "../picture/text4.1.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const swap_19_20_21_init = [
  {
    num: 19,
    icon: categoriesImg,
  },
  {
    num: 20,
    icon: imagesImg,
  },
  {
    num: 21,
    icon: attachImg,
  },
];

const SettingsEditorSegment4 = ({
  data,
  handleCheckboxChange,
  handleSetValue,
  location,
}) => {
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);

  const handleOpenCategories = () => setIsCategoriesOpen(true);
  const handleCloseCategories = () => setIsCategoriesOpen(false);

  const [swap_19_20_21, setSwap_19_20_21] = useState(swap_19_20_21_init);

  // useEffect(() => {
  //   if (!data) return

  //   if (data.swap_19_20_21 === "swap_19_20") {
  //     setSwap_19_20_21([swap_19_20_21_init[1], swap_19_20_21_init[0], swap_19_20_21_init[2]])
  //   }
  //   if (data.swap_19_20_21 === "swap_20_21") {
  //     setSwap_19_20_21([swap_19_20_21_init[0], swap_19_20_21_init[2], swap_19_20_21_init[1]])
  //   }
  //   if (data.swap_19_20_21 === "swap_19_21") {
  //     setSwap_19_20_21([swap_19_20_21_init[2], swap_19_20_21_init[1], swap_19_20_21_init[0]])
  //   }
  // }, [data?.swap_19_20_21])

  if (!data) return null;

  return (
    <>
      <div style={{ display: "flex", gap: "30px" }}>
        <div className="se-segment4">
          <div className="se-segment4-buttons" style={{ height: "70px" }}>
            {(swap_19_20_21 || []).map((sw) => (
              <Button
                key={sw.num}
                activation={true}
                style={{
                  width: "20%",
                  position: "relative",
                  opacity: sw.num === 20 && data.img_number === "0" ? 0.5 : 1,
                }}
              >
                <img src={sw.icon} />
                <div className="se-segment4-buttons-circle">{sw.num}</div>
              </Button>
            ))}
            {/* <div style={{width: "20%", position: "relative"}}>
              <img src={categoriesImg}/>
              <div className="se-segment4-buttons-circle">19</div>
            </div>
            <div style={{width: "20%", position: "relative", opacity: data.img_number === "0" ? 0.5 : 1}}>
              <img src={imagesImg}/>
              <div className="se-segment4-buttons-circle">20</div>
            </div>
            <div style={{width: "20%", position: "relative"}}>
              <img src={attachImg}/>
              <div className="se-segment4-buttons-circle">21</div>
            </div> */}
            <Button activation={true} style={{ width: "40%" }}>
              <img src={sendImg} style={{ padding: "5px 25px" }} />
            </Button>
          </div>

          <div className="se-segment4-row1">
            <div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="swap_19_20_21"
                  checked={data["swap_19_20_21"] == "swap_19_20"}
                  onChange={() => handleSetValue("swap_19_20", "swap_19_20_21")}
                />
                <div className="num-checkbox">19</div>
              </div>
              <div className="one-checbox">
                <img src={twoArrow} />
                <div className="num-checkbox">20</div>
              </div>
            </div>

            <div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="swap_19_20_21"
                  checked={data["swap_19_20_21"] == "swap_19_21"}
                  onChange={() => handleSetValue("swap_19_21", "swap_19_20_21")}
                />
                <div className="num-checkbox">19</div>
              </div>
              <div className="one-checbox">
                <img src={twoArrow} />
                <div className="num-checkbox">21</div>
              </div>
            </div>

            <div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="swap_19_20_21"
                  checked={data["swap_19_20_21"] == "swap_20_21"}
                  onChange={() => handleSetValue("swap_20_21", "swap_19_20_21")}
                />
                <div className="num-checkbox">20</div>
              </div>
              <div className="one-checbox">
                <img src={twoArrow} />
                <div className="num-checkbox">21</div>
              </div>
            </div>
          </div>

          <div className="se-segment4-row2">
            <div className="one-checbox">
              <div className="num-checkbox">19</div>
              <div style={{ marginLeft: "10px" }}>RAZNO</div>
            </div>
            <input className="se-segment4-row2-input" defaultValue="Xxxxxx" />
            <div className="one-checbox">
              <input type="checkbox" />
              <div
                onClick={handleOpenCategories}
                style={{
                  backgroundColor: "lightgray",
                  width: "25px",
                  height: "25px",
                  textAlign: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                +
              </div>
            </div>
          </div>

          <div className="se-segment4-row3">
            <div className="one-checbox">
              <div className="num-checkbox">20</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "0"}
                onChange={() => handleSetValue("0", "img_number")}
              />
              <div className="se-segment4-row3-number">0</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "1"}
                onChange={() => handleSetValue("1", "img_number")}
              />
              <div className="se-segment4-row3-number">1</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "2"}
                onChange={() => handleSetValue("2", "img_number")}
              />
              <div className="se-segment4-row3-number">2</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "3"}
                onChange={() => handleSetValue("3", "img_number")}
              />
              <div className="se-segment4-row3-number">3</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "4"}
                onChange={() => handleSetValue("4", "img_number")}
              />
              <div className="se-segment4-row3-number">4</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="img_number"
                checked={data["img_number"] == "n"}
                onChange={() => handleSetValue("n", "img_number")}
              />
              <div className="se-segment4-row3-number">n</div>
            </div>
          </div>

          <div className="se-segment4-row4">
            <img
              src={onePictureMaxImg}
              style={{ width: "70px", height: "25px" }}
            />
            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_img_size"
                checked={data["max_img_size"] == "5"}
                onChange={() => handleSetValue("5", "max_img_size")}
              />
              <div className="se-segment4-row4-number">5MB</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_img_size"
                checked={data["max_img_size"] == "10"}
                onChange={() => handleSetValue("10", "max_img_size")}
              />
              <div className="se-segment4-row4-number">10MB</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_img_size"
                checked={data["max_img_size"] == "100"}
                onChange={() => handleSetValue("100", "max_img_size")}
              />
              <div className="se-segment4-row4-number">100MB</div>
            </div>
          </div>

          <div className="se-segment4-row5">
            <div className="one-checbox">
              <input
                type="checkbox"
                name="res_34"
                checked={data.res_34}
                onChange={handleCheckboxChange}
              />
              <div className="se-segment4-row5-number">3:4</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="res_43"
                checked={data.res_43}
                onChange={handleCheckboxChange}
              />
              <div className="se-segment4-row5-number">4:3</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="res_169"
                checked={data.res_169}
                onChange={handleCheckboxChange}
              />
              <div className="se-segment4-row5-number">16:9</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="res_916"
                checked={data.res_916}
                onChange={handleCheckboxChange}
              />
              <div className="se-segment4-row5-number">9:16</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="res_xy"
                checked={data.res_xy}
                onChange={handleCheckboxChange}
              />
              <div className="se-segment4-row5-number">x:y</div>
            </div>
          </div>

          <div className="se-segment4-row6">
            <div className="one-checbox">
              <input
                type="checkbox"
                name="view_img"
                checked={data.view_img}
                onChange={handleCheckboxChange}
              />
              <img
                src={oneImageDocument}
                className="se-segment4-row6-img"
                style={{ width: "40px" }}
              />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="download_img"
                checked={data.download_img}
                onChange={handleCheckboxChange}
              />
              <img src={downloadFileImg} className="se-segment4-row6-img" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="edit_img"
                checked={data.edit_img}
                onChange={handleCheckboxChange}
              />
              <img src={penImg} className="se-segment4-row6-img" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="hide_img"
                checked={data.hide_img}
                onChange={handleCheckboxChange}
              />
              <img src={noneVisible} className="se-segment4-row6-img" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="comment_img"
                checked={data.comment_img}
                onChange={handleCheckboxChange}
              />
              <img src={messageImg} className="se-segment4-row6-img" />
            </div>
          </div>
        </div>

        <div>
          <img src={text41Img} style={{ width: "100%", height: "300px" }} />
        </div>
      </div>

      {/* Modal for Categories */}
      {isCategoriesOpen && (
        <div className="modal-overlay-cat" onClick={handleCloseCategories}>
          <div
            className="modal-content-cat"
            onClick={(e) => e.stopPropagation()}
          >
            <Categories
              location={location}
              setActiveCategoriesScreen={setIsCategoriesOpen}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SettingsEditorSegment4;
